import crm from "./crm";

const usuarioService = {
  index: () => {
    return crm.get("/usuarios/clientes");
  },
  dadosUsuario: () => {
    return crm.get("/usuarios/update");
  },
  aprovarAlteracao: (id, dados) => {
    return crm.put("/usuarios/update/" + id, dados);
  },
  buscarProponenteCpf: (id, cpf, posicao = null) => {
    return crm.get("/processo/" + id + "/proponente/" + cpf, { params: posicao ? { posicao } : {} });
  },  
  buscarFluxoPagamento: (id, conciliar=false, validarDistrato=false, conciliarAssincrono=false, validarVendaAtiva=false) => {
    return crm.get("/processo/pagamento/" + id, { params: { conciliar, validarDistrato, conciliarAssincrono, validarVendaAtiva } });
  },
};

export default usuarioService;
